import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { Core2Config } from '../../shared/core2Config';
import { BankStatementContainerModel } from '../../../../../../models/aggregates/erp/index';
import { Observable } from 'rxjs';
import { ApiVisa } from '../../shared';

@Injectable({
    providedIn: 'root'
})
export class BankStatementUploadCsvService extends BaseApiTemplateService<BankStatementContainerModel> {
    //https://api.akaun.cloud/core2/tnt/dm/erp/bank-statement/upload-csv
    readonly url = Core2Config.DOMAIN_TEST_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'erp/bank-statement/upload-csv'

    constructor(http: HttpClient) {
        super();
        this.apiUrl = Core2Config.DOMAIN_TEST_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'erp/bank-statement/upload-csv';
        this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'erp/bank-statement/upload-csv';
        this.httpClient = http;
    }

    public upload(formData: FormData, bankName: string, visa: ApiVisa, cashbookGuid : string) {
        let url = this.apiUrl + '/' + bankName;
       
        if (this.endpoint_path && visa.api_domain_url) {
            url = visa.api_domain_url + this.endpoint_path + '/' + bankName + '/' + cashbookGuid;
        }
        return this.httpClient.post(url, formData, this.getHttpHeader(visa));
    }
}
